<template>
  <div class="login-page-route-container">
    <LoginContent :isRoute="true" :hideBusinessTab="true" />
  </div>
</template>

<script>
import LoginContent from "@/components/common/LoginContent.vue";
import loginMixin from "@/utils/mixins/loginMixin";
export default {
  name: "LoginPage",
  components: {
    LoginContent,
  },
  mixins: [loginMixin],
};
</script>

<style scoped>
.login-page-route-container {
  min-height: 100vh;
  background: #f6f6f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* Ensure the login container looks centered and fits nicely on web */
@media (min-width: 1029px) {
  .login-page-route-container {
    padding: 40px 0;
  }
}
</style>
